// DMG Mock Data

export const companyInfo = {
  name: "DuPont Management Group",
  shortName: "DMG",
  tagline: "Strategic Leadership for a Complex World",
  description: "A global management consultancy and advisory firm specializing in renewable energy, food security, mining and refining operations, crisis management, and security solutions.",
  emails: {
    primary: "mark@thedupontgrp.com",
    info: "info@thedupontgrp.com"
  },
  logoUrl: "https://customer-assets.emergentagent.com/job_dupont-pros/artifacts/0mehe03n_DMG.pdf"
};

export const services = [
  {
    id: "crisis-management",
    title: "Crisis Management",
    icon: "AlertTriangle",
    shortDesc: "Precision response to high-impact, business-critical events with discretion and control.",
    fullDesc: "At DMG, Crisis Management is a core service offering that supports our clients during high-impact, business-critical events. Our multidisciplinary team responds to complex disruptions—from cyber breaches to civil unrest—with precision, control, and discretion. We specialize in corporate risk scenarios where speed, stakeholder communication, and operational continuity are essential.",
    capabilities: [
      "Cyberattack & Data Breach Containment",
      "Executive & Personnel Evacuation",
      "Civil Unrest & Political Instability Response",
      "Product Recalls & Supply Chain Disruptions",
      "Insider Threat & Whistleblower Investigations",
      "Strategic PR & Reputation Crisis Management"
    ],
    infrastructure: "Our crisis infrastructure includes 24/7 monitoring, risk audits, playbooks, rapid response teams, and senior-level advisory."
  },
  {
    id: "commercial-development",
    title: "Commercial Development",
    icon: "Building2",
    shortDesc: "Full-spectrum, vertically integrated real estate development from concept to completion and beyond.",
    fullDesc: "At DMG, Commercial Development is more than construction — it is a full-spectrum, vertically integrated service designed to take real estate projects from concept to completion and beyond. We offer turnkey development and property management solutions, ensuring our clients realize maximum value, operational efficiency, and long-term asset performance.",
    capabilities: [
      "Real Estate Acquisition & Feasibility Studies",
      "Architectural Design & Urban Planning",
      "Construction Management & Oversight",
      "Tenant Fit-Out & Commissioning",
      "Facilities & Property Management",
      "Sustainable Development Practices"
    ],
    developmentTypes: [
      "Commercial office parks and mixed-use hubs",
      "Retail centers and distribution campuses",
      "Logistics and industrial parks",
      "Government, medical, and institutional facilities",
      "Hospitality and boutique developments"
    ]
  },
  {
    id: "renewable-energy",
    title: "Renewable Energy",
    icon: "Sun",
    shortDesc: "Leading the charge in the renewable energy sector, driving the transition towards sustainable power solutions.",
    fullDesc: "At DMG, we lead the charge in the renewable energy sector, driving the transition towards sustainable power solutions. Our services include solar, wind, and hybrid energy systems, ensuring the delivery of clean and reliable energy. We design, develop, and manage large-scale renewable energy projects that significantly reduce carbon footprints and promote environmental sustainability, powering communities and industries for a greener future.",
    capabilities: [
      "Solar Energy Systems & Development",
      "Wind Power Solutions",
      "Hybrid Energy Infrastructure",
      "Clean Energy Delivery Systems",
      "Carbon Footprint Reduction",
      "Community & Industrial Power Projects"
    ]
  },
  {
    id: "food-security",
    title: "Food Security",
    icon: "Wheat",
    shortDesc: "Addressing global food security challenges through advanced agricultural technologies and sustainable practices.",
    fullDesc: "Addressing global food security challenges is central to DMG's mission. We leverage advanced agricultural technologies and sustainable farming practices to enhance food production, improve soil health, and optimize water usage. Our collaborations with local communities and international organizations help develop resilient food ecosystems capable of meeting the nutritional needs of growing populations, ensuring a stable and secure food supply chain.",
    capabilities: [
      "Advanced Agricultural Technologies",
      "Sustainable Farming Practices",
      "Soil Health Enhancement",
      "Water Usage Optimization",
      "Resilient Food Ecosystems",
      "International Organization Partnerships"
    ]
  },
  {
    id: "mining",
    title: "Mining",
    icon: "Mountain",
    shortDesc: "Dedicated to responsible and sustainable mining practices with community engagement.",
    fullDesc: "DMG is dedicated to responsible and sustainable mining practices. Our mining operations prioritize environmental stewardship, ethical sourcing, and community engagement. We extract valuable minerals and resources essential for modern industries while minimizing ecological impact and maximizing economic benefits for local communities. Our approach ensures that mining activities contribute positively to sustainable development goals.",
    capabilities: [
      "Environmental Stewardship",
      "Ethical Sourcing Standards",
      "Community Engagement Programs",
      "Sustainable Resource Extraction",
      "Ecological Impact Minimization",
      "Local Economic Development"
    ]
  },
  {
    id: "refining-operations",
    title: "Refining Operations",
    icon: "Factory",
    shortDesc: "Optimizing refining processes to increase efficiency and reduce environmental impact.",
    fullDesc: "In refining operations, DMG focuses on optimizing processes to increase efficiency and reduce environmental impact. We implement advanced technologies and best practices to refine raw materials responsibly, ensuring high-quality outputs while adhering to stringent environmental and safety standards. Our goal is to enhance the value chain from extraction to final product, supporting sustainable industrial growth.",
    capabilities: [
      "Process Optimization",
      "Advanced Refining Technologies",
      "Environmental Impact Reduction",
      "Quality Output Standards",
      "Safety Compliance",
      "Value Chain Enhancement"
    ]
  },
  {
    id: "security",
    title: "Security Expertise",
    icon: "Shield",
    shortDesc: "Unparalleled security expertise to protect assets, infrastructure, and personnel.",
    fullDesc: "DMG offers unparalleled security expertise to protect assets, infrastructure, and personnel. Our comprehensive security solutions encompass risk assessments, strategic planning, and the implementation of advanced security technologies. We design and deploy robust security frameworks tailored to the specific needs of each client, ensuring the safety and resilience of operations across all environments.",
    capabilities: [
      "Comprehensive Risk Assessments",
      "Strategic Security Planning",
      "Advanced Security Technologies",
      "Custom Security Frameworks",
      "Infrastructure Protection",
      "Personnel Safety Solutions"
    ]
  }
];

export const approach = {
  title: "Our Approach",
  description: "DMG operates through an intercontinental principal-led network, enabling on-the-ground responses and real-time decision-making tailored to client needs. We bring together capabilities across people, data, technology, and capital to address complex business challenges and deliver tangible outcomes.",
  pillars: [
    { title: "People", description: "Expert teams with decades of real-world experience" },
    { title: "Data", description: "Intelligence-driven insights for strategic decisions" },
    { title: "Technology", description: "Advanced solutions for modern challenges" },
    { title: "Capital", description: "Strategic investment facilitation" }
  ]
};

export const commitment = {
  title: "Our Commitment",
  description: "Our clients rely on DMG for sustainable growth, operational excellence, and crisis resilience. Through thoughtful leadership and practical guidance, we empower governments, businesses, and institutions to achieve long-term impact.",
  tagline: "We don't just consult—we partner, we build, we execute."
};

export const stats = [
  { value: "25+", label: "Years Experience" },
  { value: "40+", label: "Countries Served" },
  { value: "200+", label: "Projects Delivered" },
  { value: "24/7", label: "Crisis Response" }
];
